(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nv-cookie-consent"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nv-cookie-consent')){
customElements.define('nv-cookie-consent',class extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();this.keys=['analytics','marketing','preferences'];
    const options={signal:this.controller.signal};
    this.addEventListener('click',event=>{
      const button=event.target.closest('[data-consent]');if(!button)return;
      const action=button.dataset.consent;
      if(action==='manage'){this.showOptions();return;}
      const choices=Object.fromEntries(this.keys.map(key=>[key,action==='save'?this.querySelector('input[name="'+key+'"]').checked:action==='accept']));
      this.save(choices);
    },options);
    document.addEventListener('click',event=>{
      const opener=event.target.closest('[data-nv-cookie-open]');if(!opener)return;
      this.opener=opener;this.hidden=false;this.showOptions();this.init(true);
    },options);
    this.init();
  }
  disconnectedCallback(){this.controller.abort();document.documentElement.classList.remove('nv-consent-ready');clearTimeout(this.retry);clearTimeout(this.saveTimer);}
  api(){return window.Shopify?.customerPrivacy;}
  ready(){return typeof this.api()?.setTrackingConsent==='function'&&typeof this.api()?.currentVisitorConsent==='function';}
  showOptions(){this.querySelector('[data-nv-options]').hidden=false;this.querySelector('[data-consent="save"]').hidden=false;this.querySelector('[data-consent="manage"]').hidden=true;}
  init(force=false,attempt=0){
    if(this.ready()){this.sync(force);return;}
    if(window.Shopify?.loadFeatures&&!this.loading){
      this.loading=true;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{this.loading=false;if(!error&&this.ready())this.sync(force);else if(force)this.status(this.dataset.error);});
    }
    if(attempt<20)this.retry=setTimeout(()=>{if(this.isConnected)this.init(force,attempt+1);},500);
    else if(force)this.status(this.dataset.error);
  }
  sync(force){
    clearTimeout(this.retry);
    try{
      const consent=this.api().currentVisitorConsent();
      this.keys.forEach(key=>{this.querySelector('input[name="'+key+'"]').checked=consent[key]==='yes';});
      document.documentElement.classList.add('nv-consent-ready');
      this.hidden=!(force||this.keys.some(key=>consent[key]!=='yes'&&consent[key]!=='no'));
    }catch{if(force)this.status(this.dataset.error);}
  }
  status(text){this.querySelector('[data-nv-consent-status]').textContent=text;}
  async save(choices){
    if(this.saving)return;
    if(!this.ready()){this.status(this.dataset.error);this.init(true);return;}
    this.saving=true;this.status('');this.querySelectorAll('button').forEach(b=>b.disabled=true);
    try{
      await new Promise((resolve,reject)=>{
        this.saveTimer=setTimeout(()=>reject(new Error('timeout')),8000);
        this.api().setTrackingConsent(choices,result=>{
          clearTimeout(this.saveTimer);
          if(result?.error){reject(new Error('consent'));return;}
          try{const current=this.api().currentVisitorConsent();if(this.keys.every(key=>current[key]===(choices[key]?'yes':'no')))resolve();else reject(new Error('unconfirmed'));}catch(error){reject(error);}
        });
      });
      this.status(this.dataset.saved);this.hidden=true;this.opener?.focus();
    }catch{this.hidden=false;this.status(this.dataset.error);}
    finally{clearTimeout(this.saveTimer);this.saving=false;this.querySelectorAll('button').forEach(b=>b.disabled=false);}
  }
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nv-shipping-progress"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nv-shipping-progress')){
  customElements.define('nv-shipping-progress',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      document.addEventListener('navary:cart:updated',e=>this.updateCart(e.detail),{signal:this.controller.signal});
      document.addEventListener('navary:cart:error',()=>{this.hidden=true;},{signal:this.controller.signal});
    }
    disconnectedCallback(){this.controller.abort();}
    updateCart(cart){
      this.hidden=!cart.items.some(item=>item.requires_shipping);
      const threshold=Number(this.dataset.threshold);
      const remaining=Math.max(0,threshold-cart.total_price);
      const bar=this.querySelector('progress');
      bar.hidden=cart.currency!=='EUR';
      bar.value=Math.min(100,cart.total_price/threshold*100);
      this.querySelector('[data-nv-shipping-message]').textContent=cart.currency!=='EUR'?this.dataset.conversion:remaining===0?this.dataset.won:this.dataset.left.replace('[amount]',new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:'EUR'}).format(remaining/100));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vm-cart-dock"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vm-cart-dock')){
class VmCartDock extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();
    const options={signal:this.controller.signal};
    this.revision=0;
    this.pending=0;
    this.syncing=false;
    this.uncertain=true;
    this.querySelector('form').addEventListener('submit',event=>{
      if(this.uncertain||this.pending||this.syncing){event.preventDefault();window.location.assign(this.dataset.cartUrl);}
    },options);
    document.body.classList.toggle('vm-cart-present',!this.hidden);
    this.resizeObserver=new ResizeObserver(()=>this.measure());
    this.resizeObserver.observe(this);
    for(const name of ['shopify:cart:lines-update','shopify:cart:discount-update'])document.addEventListener(name,event=>this.onCartEvent(event),options);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.refresh();},options);
    window.addEventListener('pageshow',()=>this.refresh(),options);
    this.refresh();
  }
  disconnectedCallback(){this.controller.abort();this.request?.abort();this.resizeObserver.disconnect();document.body.classList.remove('vm-cart-present');document.documentElement.style.setProperty('--vm-cart-dock-height','0px');}
  measure(){document.documentElement.style.setProperty('--vm-cart-dock-height',this.hidden?'0px':this.getBoundingClientRect().height+'px');}
  setBusy(){this.querySelector('button[name="checkout"]').disabled=this.pending>0||this.syncing;}
  async bounded(promise,milliseconds){
    let timer;
    try{return await Promise.race([promise,new Promise((resolve,reject)=>{timer=setTimeout(()=>reject(new Error('timeout')),milliseconds);})]);}
    finally{clearTimeout(timer);}
  }
  async onCartEvent(event){
    const lifecycle=this.controller;
    this.pending++;
    this.uncertain=true;
    this.revision++;
    this.request?.abort();
    this.setBusy();
    let timedOut=false;
    try{if(event.promise)await this.bounded(event.promise,18000);}catch(error){timedOut=error?.message==='timeout';}
    if(lifecycle!==this.controller||!this.isConnected)return;
    this.pending--;
    if(timedOut){
      this.syncing=false;
      this.showError();
      Promise.resolve(event.promise).catch(()=>{}).then(()=>{if(this.isConnected&&lifecycle===this.controller)this.refresh();});
    }else await this.refresh();
    this.setBusy();
  }
  showError(){document.dispatchEvent(new CustomEvent('navary:cart:error'));this.uncertain=true;this.querySelector('[data-vm-total]').textContent='—';this.querySelector('[data-vm-offer]').textContent='';this.querySelector('[data-vm-status]').textContent=this.dataset.errorLabel;this.measure();}
  async refresh(){
    const revision=++this.revision;
    this.request?.abort();
    const request=new AbortController();
    this.request=request;
    this.syncing=true;
    this.setBusy();
    try{
      const cart=await this.bounded((async()=>{
        const response=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'},cache:'no-store',signal:request.signal});
        if(!response.ok)throw new Error('cart');
        return response.json();
      })(),8000);
      if(revision!==this.revision||!this.isConnected)return;
      this.uncertain=this.pending>0;
      this.querySelector('[data-vm-status]').textContent='';
      this.hidden=cart.item_count===0;
      document.body.classList.toggle('vm-cart-present',!this.hidden);
      this.querySelector('[data-vm-count]').textContent=this.dataset.countLabel.replace('[count]',String(cart.item_count));
      this.querySelector('[data-vm-total]').textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:cart.currency}).format(cart.total_price/100);
      const eligible=cart.items.filter(item=>!item.gift_card).reduce((sum,item)=>sum+item.quantity,0);
      const offer=this.querySelector('[data-vm-offer]');
      const applications=[...(cart.cart_level_discount_applications||[]),...cart.items.flatMap(item=>(item.discount_allocations||item.line_level_discount_allocations||[]).map(a=>a.discount_application).filter(Boolean))];
      const codes=applications.filter(a=>a.type==='discount_code');
      offer.textContent=codes.some(a=>a.title?.toUpperCase()==='SARAH10')?this.dataset.sarahApplied:codes.length?this.dataset.codeApplied:eligible<2?this.dataset.stepOne:eligible<3?this.dataset.stepTwo:this.dataset.stepThree;
      this.querySelector('[data-vm-delivery]').hidden=!cart.items.some(item=>item.requires_shipping);
      document.dispatchEvent(new CustomEvent('navary:cart:updated',{detail:cart}));
      this.measure();
    }catch{if(revision===this.revision&&this.isConnected)this.showError();}
    finally{request.abort();if(revision===this.revision&&this.isConnected){this.syncing=false;this.setBusy();}}
  }
}
customElements.define('vm-cart-dock',VmCartDock);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vm-region-select"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{for(const details of document.querySelectorAll('.vm-region[open]')){if(!details.contains(event.target))details.open=false;}});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){for(const details of document.querySelectorAll('.vm-region[open]')){details.open=false;details.querySelector('summary').focus();}}});
  } catch(e) { console.error(e); }
})();

})();
